import React, {useEffect, useState, useCallback} from 'react';
import {v4 as uuid} from 'uuid';

import {
  Container,
  Content,
  ContentHeader,
  Form,
  FormFooter,
  LoadingList,
  LoadingShimmerContainer,
  NotFoundContainer,
  FormSurface,
  FilterPill,
  FilterPillText,
  FilterBadge,
  FilterBadgeText,
  Hero,
  FilterIconContainer,
  FilterIcon,
  FilterInfos,
  FilterPillDescription,
  FilterGradient,
} from './styles';
import {Header} from '../../../components/Interface/Headers/Header';
import {useIsFocused, useNavigation, useRoute} from '@react-navigation/native';
import {SearchInput} from '../../../components/Interface/Forms/Inputs/SearchInput';
import {RFValue} from 'react-native-responsive-fontsize';
import {ParceiroDTO} from '../../../dtos/ParceiroDTO';

import {apiMasterClin} from '../../../services/api';
import {getCache, setCache, CACHE_KEYS} from '../../../services/cache';

import {StoreItem} from '../../../components/shared/Stores/StoreItem';
import {Titles} from '../../../components/Interface/Typographies/Titles';

import {FlatList} from 'react-native-gesture-handler';

import {NotFound} from '../../../components/Interface/Search/NotFound';
import {StoreShimmer} from '../../../components/Interface/Loadings/ClubeShimmer/StoreShimmer';
import {
  ActivityIndicator,
  Keyboard,
  TouchableWithoutFeedback,
} from 'react-native';
import FiltersBottomSheet from './FiltersBottomSheet';

interface Params {
  categoria: string;
  cidade: number;
  bairro: number;
  estado: number;
  destaques: boolean;
}

export function StoreSearch() {
  const navigation = useNavigation();
  const route = useRoute();
  const screenIsFocus = useIsFocused();

  const {bairro, cidade, estado, categoria, destaques} = route.params as Params;

  const [storesData, setStoresData] = useState<ParceiroDTO[]>(
    [] as ParceiroDTO[],
  );

  const [page, setPage] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);

  const [search, setSearch] = useState('');
  const [showFiltersBottomSheet, setShowFiltersBottomSheet] = useState(false);
  const [filters, setFilters] = useState({
    estado,
    cidade,
    bairro,
    categoria,
  });

  const bairroFilter = filters.bairro ? filters.bairro : '';
  const cidadeFilter = filters.cidade ? filters.cidade : '';
  const estadoFilter = filters.estado ? filters.estado : '';

  const fetchUnitsByPage = async () => {
    if (page < totalPaginas) {
      await apiMasterClin
        .get(
          '/parceiro?pesquisa=' +
            search +
            '&page=' +
            (page + 1) +
            '&estado=' +
            estadoFilter +
            '&bairro=' +
            bairroFilter +
            '&cidade=' +
            cidadeFilter,
        )
        .then(({data}) => {
          const {dados} = data;

          setPage(page + 1);

          setStoresData([...storesData, ...dados]);
        })
        .catch(({response}) => {
          const {mensagem} = response.data;

          if (mensagem) {
            navigation.navigate('ConfirmationScreen', {
              type: 'error',
              buttonAction: () => navigation.navigate('Initial'),
              buttonText: 'Ir para a tela inicial',
              closeIconAction: () => navigation.navigate('Initial'),
              text: mensagem,
              title: 'Ocorreu um problema',
            });
          } else {
            navigation.navigate('ConfirmationScreen', {
              type: 'error',
              buttonAction: () => navigation.navigate('Initial'),
              buttonText: 'Ir para a tela inicial',
              closeIconAction: () => navigation.navigate('Initial'),
              text: 'Ocorreu um erro no processamento. Entre em contato com nosso suporte para obter ajuda.',
              title: 'Ocorreu um problema',
            });
          }
        });
    }
  };

  let isMounted = true;

  async function fetchUnits() {
    if (destaques) {
      // Tentar buscar do cache primeiro
      const cached = await getCache<ParceiroDTO[]>(CACHE_KEYS.MASTERCLIN_DESTAQUES);
      if (cached && isMounted) {
        setStoresData(cached);
        return;
      }

      await apiMasterClin
        .get('/parceiro/obter-destaques')
        .then(({data}) => {
          const {parceiros} = data;

          if (parceiros) {
            if (isMounted) {
              setStoresData(parceiros);
              // Salvar no cache por 7 dias
              setCache(CACHE_KEYS.MASTERCLIN_DESTAQUES, parceiros);
            }
          }
        })
        .catch(({response}) => {
          const {mensagem} = response.data;

          if (mensagem) {
            navigation.navigate('ConfirmationScreen', {
              type: 'error',
              buttonAction: () => navigation.navigate('Initial'),
              buttonText: 'Ir para a tela inicial',
              closeIconAction: () => navigation.navigate('Initial'),
              text: mensagem,
              title: 'Ocorreu um problema',
            });
          } else {
            navigation.navigate('ConfirmationScreen', {
              type: 'error',
              buttonAction: () => navigation.navigate('Initial'),
              buttonText: 'Ir para a tela inicial',
              closeIconAction: () => navigation.navigate('Initial'),
              text: 'Ocorreu um erro no processamento. Entre em contato com nosso suporte para obter ajuda.',
              title: 'Ocorreu um problema',
            });
          }
        })
        .finally(() => {
          if (isMounted) {
            isMounted = false;
          }
        });
    } else {
      await apiMasterClin
        .get(
          '/parceiro?estado=' +
            estadoFilter +
            '&bairro=' +
            bairroFilter +
            '&cidade=' +
            cidadeFilter,
        )
        .then(({data}) => {
          const {dados, paginaFinal} = data;

          setTotalPaginas(paginaFinal);

          if (dados) {
            if (isMounted) {
              setStoresData(dados);
            }
          }
        })
        .catch(({response}) => {
          const {mensagem} = response.data;

          if (mensagem) {
            navigation.navigate('ConfirmationScreen', {
              type: 'error',
              buttonAction: () => navigation.navigate('Initial'),
              buttonText: 'Ir para a tela inicial',
              closeIconAction: () => navigation.navigate('Initial'),
              text: mensagem,
              title: 'Ocorreu um problema',
            });
          } else {
            navigation.navigate('ConfirmationScreen', {
              type: 'error',
              buttonAction: () => navigation.navigate('Initial'),
              buttonText: 'Ir para a tela inicial',
              closeIconAction: () => navigation.navigate('Initial'),
              text: 'Ocorreu um erro no processamento. Entre em contato com nosso suporte para obter ajuda.',
              title: 'Ocorreu um problema',
            });
          }
        })
        .finally(() => {
          if (isMounted) {
            isMounted = false;
          }
        });
    }
  }

  useEffect(() => {
    setStoresData([]);
    fetchUnits();

    return () => {
      isMounted = false;
    };
  }, [screenIsFocus]);

  const RenderItem = useCallback(
    ({item, index}: any) => (
      <StoreItem asPadding data={item} first={index === 0} />
    ),
    [],
  );

  async function fetchStoresSearchByTerm(text: string) {
    setSearch(text);
    setPage(1);

    if (!text) {
      fetchUnits();
    }

    await apiMasterClin
      .get(
        '/parceiro?pesquisa=' +
          search +
          '&page=1' +
          '&estado=' +
          estadoFilter +
          '&bairro=' +
          bairroFilter +
          '&cidade=' +
          cidadeFilter,
      )
      .then(({data}) => {
        const {dados} = data;

        setStoresData(dados);
      })
      .catch(({response}) => {
        const {mensagem} = response.data;

        if (mensagem) {
          navigation.navigate('ConfirmationScreen', {
            type: 'error',
            buttonAction: () => navigation.navigate('Initial'),
            buttonText: 'Ir para a tela inicial',
            closeIconAction: () => navigation.navigate('Initial'),
            text: mensagem,
            title: 'Ocorreu um problema',
          });
        } else {
          navigation.navigate('ConfirmationScreen', {
            type: 'error',
            buttonAction: () => navigation.navigate('Initial'),
            buttonText: 'Ir para a tela inicial',
            closeIconAction: () => navigation.navigate('Initial'),
            text: 'Ocorreu um erro no processamento. Entre em contato com nosso suporte para obter ajuda.',
            title: 'Ocorreu um problema',
          });
        }
      });
  }

  const filterByCategory = storesData.filter(
    item => item.categoria[0].nome === filters.categoria,
  );

  const filterCount = () => {
    const arrayFilters = [filters.bairro, filters.cidade, filters.estado, filters.categoria];

    const arrayFiltersCount = arrayFilters.filter(item => item !== undefined);

    return arrayFiltersCount.length;
  };
  const filtersApplied = filterCount();

  const handleApplyFilters = (newFilters: any) => {
    setFilters(newFilters);
    setPage(1);
    setStoresData([]);
  };

  return (
    <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
      <Container>
        <Header icon="chevron-left" action={() => navigation.goBack()} />
        <ContentHeader>
          <Titles title={!destaques ? 'Parceiros' : 'Destaques'} />
        </ContentHeader>
        {!destaques && (
          <Hero>
            <Form>
              <FormSurface>
                <SearchInput
                  placeholder="Busque por parceiros"
                  value={search}
                  onChangeText={fetchStoresSearchByTerm}
                />
              </FormSurface>
            </Form>
            <FormFooter>
              <FilterPill
                activeOpacity={1}
                onPress={() => setShowFiltersBottomSheet(true)}>
                <FilterGradient
                  colors={['#00c17a', '#01D185']}
                  start={{y: 0, x: 0}}
                  end={{y: 1, x: 1}}>
                  <FilterIconContainer>
                    <FilterIcon name="sliders-h" />
                  </FilterIconContainer>

                  <FilterInfos>
                    <FilterPillText>Filtrar lojas</FilterPillText>
                    <FilterPillDescription>
                      Refine sua busca
                    </FilterPillDescription>
                  </FilterInfos>
                </FilterGradient>
              </FilterPill>
            </FormFooter>
          </Hero>
        )}
        <Content>
          {storesData.length !== 0 ? (
            <>
              {categoria ? (
                filterByCategory.length !== 0 ? (
                  <FlatList
                    data={categoria ? filterByCategory : storesData}
                    keyExtractor={() => uuid()}
                    showsVerticalScrollIndicator={false}
                    contentContainerStyle={{paddingBottom: RFValue(20)}}
                    onEndReachedThreshold={0.1}
                    onEndReached={fetchUnitsByPage}
                    style={{marginHorizontal: -24}}
                    renderItem={RenderItem}
                    ListFooterComponent={
                      <>
                        {page < totalPaginas && !destaques && (
                          <LoadingList>
                            <ActivityIndicator />
                          </LoadingList>
                        )}
                      </>
                    }
                  />
                ) : (
                  <NotFoundContainer>
                    <NotFound />
                  </NotFoundContainer>
                )
              ) : storesData.length !== 0 ? (
                <FlatList
                  data={categoria ? filterByCategory : storesData}
                  keyExtractor={() => uuid()}
                  showsVerticalScrollIndicator={false}
                  contentContainerStyle={{paddingBottom: RFValue(20)}}
                  onEndReachedThreshold={0.1}
                  onEndReached={fetchUnitsByPage}
                  style={{marginHorizontal: -24}}
                  renderItem={RenderItem}
                  ListFooterComponent={
                    <>
                      {page < totalPaginas && (
                        <LoadingList>
                          <ActivityIndicator />
                        </LoadingList>
                      )}
                    </>
                  }
                />
              ) : (
                <NotFoundContainer>
                  <NotFound />
                </NotFoundContainer>
              )}
            </>
          ) : (
            <LoadingShimmerContainer>
              <StoreShimmer />
              <StoreShimmer />
              <StoreShimmer />
              <StoreShimmer />
              <StoreShimmer />
              <StoreShimmer />
              <StoreShimmer />
              <StoreShimmer />
              <StoreShimmer />
            </LoadingShimmerContainer>
          )}
        </Content>
        <FiltersBottomSheet
          isOpen={showFiltersBottomSheet}
          onClose={() => setShowFiltersBottomSheet(false)}
          onApply={handleApplyFilters}
          initialFilters={filters}
        />
      </Container>
    </TouchableWithoutFeedback>
  );
}
